import script from "./BlogsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogsSection.vue?vue&type=script&setup=true&lang=js"

import "./BlogsSection.vue?vue&type=style&index=0&id=1a6cb0f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a6cb0f6"]])

export default __exports__